module.exports = __webpack_public_path__ + "static/media/gallery1.5dcef1e0.jpg";